import { Endpoint } from '@philips-emr/hpms-provider-commons';
import { PDFViewerAPI } from '@philips-emr/tws-components';
import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';
import { MountEvent } from '@philips-emr/tws-core/lib/component/types';

import { PdfViewerAliases as Aliases, FragmentNames } from '../codegen';

import BaseController from './BaseController';

@Controller({ fragment: FragmentNames.PDF_VIEWER })
export default class PDFViewerController extends BaseController {

  @OnMount(Aliases.PDF_VIEWER)
  onMountPdf(event: MountEvent): void {
    const api = event.target as PDFViewerAPI;
    const { src } = this.context.getBulkData();
    const encode = Buffer.from(src as string).toString('base64');
    api.setSrc(Endpoint.GET.REPORT_BY_PATH.replace(':path', encode));
  }
}
